<template>
  <v-simple-checkbox
    color="primary"
    v-model="absence[property]"
    :disabled="isDisabled"
    @input="$emit('inlineChange', { absence, property })"
  ></v-simple-checkbox>
</template>
<script>
export default {
  name: 'CheckboxCell',
  props: {
    absence: Object,
    isAssignedToDifferentView: Boolean,
    isDisabled: { type: Boolean, default: false },
    property: String,
  },
};
</script>
